<app-progress-bar></app-progress-bar>
<router-outlet></router-outlet>
@if (isSpinnerVisible) {
  <mat-progress-bar class="loader" mode="indeterminate" value="40"></mat-progress-bar>
}
